import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { DataLoadState, ErrorType, initialDataLoadState } from '../../../store/reducers/common';

export type PersonaState = {
  inquiryId?: string;
} & DataLoadState;

const initialPersonaState: PersonaState = {
  ...initialDataLoadState,
};

const slice = createSlice({
  name: 'config',
  initialState: initialPersonaState,
  reducers: {
    loadPersona: (state) => ({
      ...state,
      loading: true,
      error: null,
    }),
    loadPersonaSuccess: (state, { payload }: PayloadAction<string>) => ({
      ...state,
      loading: false,
      inquiryId: payload,
    }),
    loadPersonaFail: (state, { payload: { message } }: PayloadAction<ErrorType>) => ({
      ...state,
      loading: false,
      error: { message },
    }),
  },
});

export const personaReducer = slice.reducer;
export const { loadPersona, loadPersonaSuccess, loadPersonaFail } = slice.actions;
